import { createSelector } from 'reselect';
import { expVal } from '@atlassian/jira-feature-experiments';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/index.tsx';
import {
	getIsCMPBoard,
	getIsIncrementPlanningBoard,
	getIsJSWBoard,
	projectTypeSelector,
} from '../software/software-selectors.tsx';
import { shouldDisplayFilterRefinement } from '../../../common/utils/should-display-filter-refinement/index.tsx';

export const isFilterRefinementEnabled = createSelector(
	[getIsIncrementPlanningBoard, getIsCMPBoard, getIsJSWBoard, projectTypeSelector],
	(isIPBoard, isCMPBoard, isJSWBoard, projectType) => {
		const displayFilterRefinement = shouldDisplayFilterRefinement({
			isIncrementPlanningBoard: isIPBoard,
			isCMPBoard,
			isJSMBoard: projectType === SERVICE_DESK_PROJECT,
			isJSWBoard,
		});

		return displayFilterRefinement && expVal('filter_refinement_in_tmp_board', 'isEnabled', false);
	},
);
